import React from 'react';
import cx from 'classnames';
import Tag from '../tag';
var clsPrefix = 'tcpc-select-item';

var SelectItem = function SelectItem(props) {
  var className = props.className,
      style = props.style,
      children = props.children,
      selected = props.selected,
      _onClick = props.onClick,
      title = props.title,
      data = props.data,
      active = props.active,
      onActive = props.onActive,
      size = props.size;
  var isExit = data.findIndex(function (element) {
    return selected.id === element.id;
  });
  var baseProps = {
    style: style,
    className: cx(clsPrefix, className, "".concat(clsPrefix, "-").concat(size), {
      active: active
    })
  };
  return /*#__PURE__*/React.createElement("div", Object.assign({}, baseProps), /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-title")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-headline")
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-main")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-list")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-hot")
  }, Array.isArray(data) && data.map(function (item) {
    return /*#__PURE__*/React.createElement(Tag, {
      onClick: function onClick() {
        return _onClick && _onClick(item);
      },
      className: "".concat(clsPrefix, "-tag"),
      selected: selected.id === item.id,
      key: item.name
    }, item.name);
  }), selected.name !== '' && isExit === -1 && /*#__PURE__*/React.createElement(Tag, {
    className: "".concat(clsPrefix, "-tag"),
    selected: true
  }, selected.name)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-more"),
    onClick: onActive
  }, active ? '收起' : '更多', /*#__PURE__*/React.createElement("i", {
    className: "".concat(clsPrefix, "-arrow-bottom")
  }))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "-content")
  }, children)));
};

SelectItem.defaultProps = {
  size: 'large'
};
export default SelectItem;